/* SP card swatches — al pasar el ratón por una variante de color, la imagen principal
   de la tarjeta cambia a la de esa variante; al salir vuelve a la activa. Click fija la activa.
   Delegado en document → una sola carga sirve para listado, carruseles y recomendados. */
(function () {
  if (window.__spSwatchBound) return;
  window.__spSwatchBound = true;

  function mainImg(sw) {
    var card = sw.closest('.sp-pcard');
    return card ? card.querySelector('.sp-pcard__img') : null;
  }
  function setImg(img, url) {
    if (!img || !url) return;
    img.setAttribute('srcset', '');
    img.removeAttribute('sizes');
    img.src = url;
  }
  // Mensaje de stock del color (Recíbelo / ¡Últimas unidades! / Agotado)
  function setStock(card, state) {
    if (!card || !state) return;
    var el = card.querySelector('.sp-pcard__stock'); if (!el) return;
    var lbl = el.getAttribute('data-lbl-' + state); if (lbl == null) return;
    el.className = 'sp-pcard__stock sp-pcard__stock--' + state;
    var t = el.querySelector('.sp-pcard__stock-txt'); if (t) t.textContent = lbl;
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.sp-pcard__swatch');
    if (!sw) return;
    var img = mainImg(sw);
    if (!img) return;
    if (!img.dataset.spOrig) { img.dataset.spOrig = img.currentSrc || img.src; }
    setImg(img, sw.getAttribute('data-img'));
    setStock(sw.closest('.sp-pcard'), sw.getAttribute('data-stock'));
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest('.sp-pcard__swatch');
    if (!sw) return;
    var card = sw.closest('.sp-pcard');
    if (!card) return;
    var img = card.querySelector('.sp-pcard__img');
    var active = card.querySelector('.sp-pcard__swatch.is-active');
    if (active) { setImg(img, active.getAttribute('data-img')); setStock(card, active.getAttribute('data-stock')); }
    else if (img && img.dataset.spOrig) { setImg(img, img.dataset.spOrig); }
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.sp-pcard__swatch');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.sp-pcard');
    card.querySelectorAll('.sp-pcard__swatch').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
    setImg(card.querySelector('.sp-pcard__img'), sw.getAttribute('data-img'));
    setStock(card, sw.getAttribute('data-stock'));
  });

  // Al cargar: alinea el mensaje de cada tarjeta con su color activo (swatch is-active).
  function initStock() {
    document.querySelectorAll('.sp-pcard__swatch.is-active').forEach(function (sw) {
      setStock(sw.closest('.sp-pcard'), sw.getAttribute('data-stock'));
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initStock); } else { initStock(); }
})();
